module.exports = __webpack_public_path__ + "img/dl5.5afd5dd1.jpg";